const countryCodes = {
  SE: '46',
  NO: '47',
  DK: '45',
  DE: '49',
  CH: '41'
};

const formatMobileNumber = (number, country) => {
  // Convert to string in case it's a number
  let strNumber = String(number);

  // Remove any non-digit characters
  strNumber = strNumber.replace(/\D/g, '');

  const constryCodePrefix = countryCodes[country];

  if (strNumber.startsWith(constryCodePrefix)) {
    return strNumber;
  }

  if (country === 'SE') {
    if (strNumber.startsWith('07')) {
      return `${constryCodePrefix}${strNumber.substring(1)}`;
    }
    if (strNumber.startsWith('7')) {
      return `${constryCodePrefix}7${strNumber.substring(1)}`;
    }
  }

  return number;
};

export default formatMobileNumber;

// console.log(formatMobileNumber('707100795'));      // 46707100795
// console.log(formatMobileNumber('0707100795'));     // 46707100795
// console.log(formatMobileNumber('+46707100795'));   // 46707100795
